module.exports = __webpack_public_path__ + "static/img/logo_qvwen.1db7de9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_qvwen.png
// module id = whos
// module chunks = 0